import React from "react";
import { object, string } from "prop-types";
import { Link } from "@quintype/components";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { getTemplateName } from "../../utils";
import { getCategoryAndSubCategory } from "../../../ga-utils";

import { MenuItem } from "../../layouts/menu-item";

import "./FooterMenuGroup.m.css";

export const MenuGroup = ({ menus, customStyle, story, config, isStatic = false }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const pageType = get(qtState, ["pageType"], null);

  const trackFooterClick = (e, item, category) => {
    e.preventDefault();
    e.stopPropagation();
    window.dataLayer = window.dataLayer || [];
    const url = item.completeUrl || item.url || "/";

    let categoryInfo = getCategoryAndSubCategory(window.location, pageType, config, story);
    const templateName = pageType === "story-page" ? getTemplateName(story?.["story-template"]) : getTemplateName(pageType);

    window.dataLayer.push({
      event: "dl_footer_clicks",
      link_url: url,
      link_text: item.title?.toLowerCase(),
      link_category: isStatic ? "static" : category?.toLowerCase(),
      category: categoryInfo?.category,
      sub_category: categoryInfo.subCategory,
      content_id: categoryInfo.contentId,
      template_name: templateName,
      platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      eventCallback: function () {
        if (url) {
          window.location.href = url;
        }
      },
    });
  };

  const menuListItem = (footerMenuItem, customStyle, parentTitle) => (
    <li styleName={`list-item ${customStyle}`} key={footerMenuItem?.id} className="list-item">
      <div onClick={(e) => trackFooterClick(e, footerMenuItem, parentTitle)} style={{ display: "contents" }}>
        <MenuItem item={footerMenuItem} menuStyle="menu-items-footer" />
      </div>
    </li>
  );

  const footerMenuWithChildren = (menuItem, customStyle) => {
    const { title, children, url, "item-type": type } = menuItem;

    return (
      <div key={menuItem?.id} aria-label={`${title} list`} styleName="menu-group">
        {type === "placeholder" ? (
          <div styleName="title" tabIndex={0}>
            {title}
          </div>
        ) : (
          <div onClick={(e) => trackFooterClick(e, menuItem)} style={{ display: "contents" }}>
            <Link style={{ display: "block" }} href={url} styleName="title" disableAjaxLinks={true}>
              {title}
            </Link>
          </div>
        )}
        <ul styleName="footer-menu-group">{children.map((item) => menuListItem(item, customStyle, title))}</ul>
      </div>
    );
  };

  return menus.map((menuItem) => {
    return menuItem?.children?.length
      ? footerMenuWithChildren(menuItem, customStyle)
      : menuListItem(menuItem, customStyle);
  });
};

MenuGroup.defaultProps = {
  menu: {},
  customStyle: "",
};

MenuGroup.propTypes = {
  menu: object,
  customStyle: string,
};
